<mat-card>
  <mat-card-content>
    <fs-list [config]="config">
      <fs-list-column class="fs-list-col-shrink">
        <ng-template
            fs-list-cell
            let-row="row">
          <fs-badge
            shape="circle"
            [image]="row.avatar?.tiny">
          </fs-badge>
        </ng-template>
      </fs-list-column>
      <fs-list-column
          name="status_name"
          title="Status"
          [sortable]="true"
          class="fs-list-col-shrink">
        <ng-template
            fs-list-cell
            let-row="row">
          @if (row.status) {
            <app-status-pill [status]="row.status"></app-status-pill>
          }
        </ng-template>
      </fs-list-column>
      <fs-list-column
          name="name"
          title="Name"
          [sortable]="true">
        <ng-template
            fs-list-cell
            let-row="row">
          <div>
            @if (row.state !== 'deleted') {
              {{ row.name }}
              <div class="links">
                @for (item of links; track item) {
                  <a
                      *fsAclRead="[
                         { permission: item.permission, object: environmentId },
                         { permission: item.permission, object: row.id }
                        ]"
                      [routerLink]="['../projects', row.id, item.value]">
                    {{ item.name }}
                  </a>
                }
              </div>
            } @else {
              <span>
                {{ row.name }}
              </span>
            }
          </div>
        </ng-template>
      </fs-list-column>
      <fs-list-column class="col-goto">
        <ng-template
            fs-list-cell
            let-row="row">
          <mat-select
              [(ngModel)]="row.goto"
              (ngModelChange)="goToChanged(row, $event)"
              fsSelectButton
              placeholder="Goto">
            @for (item of links; track item) {
              <mat-option [value]="item.value">
                {{ item.name }}
              </mat-option>
            }
          </mat-select>
        </ng-template>
      </fs-list-column>
    </fs-list>
  </mat-card-content>
</mat-card>